import React from "react";
import './Boton.scss'


const Boton = ({width="fit-content",children,onClick,background,className,disabled,id})=>
{
    return(
        <button className={`Boton ${className}`} id={id} disabled={disabled} onClick={onClick} style={{width:width,background:background}}>{children}</button>
    )
}
export default Boton